<template>
  <DialogFull :data="dialogSettings" @close="onSubmit">
    <template v-slot:dialog.body>
      <div class="container col-md-8 col-sm-12">
        <div>
          <v-img
            :src="require('@/assets/svg/application-submitted.svg')"
            alt="Application Submitted"
            class="mb-5 mt-5"
            height="140"
            contain
          />
          <h2 class="mb-2 d-flex justify-center text-center">
            Your application for {{ currentBooking.title }} has been submitted
          </h2>
          <span class="secondary-text d-flex justify-center text-center mb-5">
            A confirmation email has been sent
          </span>
        </div>
        <div class="d-flex justify-center">
          <PrimaryButton @click.native="onSubmit">
            Continue
          </PrimaryButton>
        </div>
      </div>
    </template>
  </DialogFull>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { BOOKINGS_NAMESPACE } from "@/store/modules/bookings/actions";
import { createNamespacedHelpers } from "vuex";
import { GET_CURRENT_BOOKING } from "@/store/modules/bookings/getters";
import DialogFull from "@/components/common/DialogFull";

const { mapGetters } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  name: "ApplicationSubmitted",
  components: {
    PrimaryButton,
    DialogFull
  },
  computed: {
    ...mapGetters({
      currentBooking: GET_CURRENT_BOOKING
    }),
    dialogSettings() {
      return {
        dialog: true,
        title: "New Application"
      };
    }
  },
  methods: {
    onSubmit() {
      this.$router.push("/profile-submitted");
    }
  }
};
</script>

<style lang="scss"></style>
